module.exports = __webpack_public_path__ + "static/media/roboto-v18-latin-ext_latin-regular.1fb51f52.woff";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/roboto-v18-latin-ext_latin-regular.woff
// module id = ./src/common/fonts/roboto-v18-latin-ext_latin-regular.woff
// module chunks = 1